import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { mainBtnClassName } from '../../../constants';
import Icon, { iconNames } from '../icon';
import i18n from '../../../services/i18n';

const UNSAFE_SEGMENT_RE = /\/(null|undefined|NaN)(?=\/|$)/i;

const sanitizePath = (path) => {
    if (typeof path !== 'string' || !path) return path;
    if (path.startsWith('http') || path.startsWith('mailto:') || path.startsWith('tel:')) {
        return path;
    }
    if (!UNSAFE_SEGMENT_RE.test(path)) return path;
    const cleaned = path.replace(/\/(null|undefined|NaN)(?=\/|$)/gi, '');
    return cleaned || '/';
};

export const addLangPrefix = (to) => {
    if (typeof to === 'object' && to !== null && to.pathname) {
        const prefixedPathname = addLangPrefixToString(sanitizePath(to.pathname));
        return {
            ...to,
            pathname: prefixedPathname,
        };
    }
    return addLangPrefixToString(sanitizePath(to));
};

const addLangPrefixToString = (to) => {
    if (!to || typeof to !== 'string' || to === '/') {
        return `/${i18n.language}/`;
    }

    const hasLang = /^\/[a-z]{2}\//.test(to) || /^\/[a-z]{2}$/.test(to);
    if (hasLang) {
        if (/^\/[a-z]{2}$/.test(to)) {
            return `${to}/`;
        }
        return to;
    }

    if (
        to.startsWith('http') ||
        to.startsWith('#') ||
        to.startsWith('mailto:') ||
        to.startsWith('tel:')
    ) {
        return to;
    }

    return `/${i18n.language}${to}`;
};

export const Link = ({
    to,
    text,
    className,
    textStyle,
    onClick,
    title,
    ariaLabel,
}) => {
    const { t } = useTranslation();
    const linkText = text || t('more');
    const finalTo = addLangPrefix(to);

    return (
        <RouterLink
            className={className}
            to={finalTo}
            style={textStyle}
            onClick={onClick}
            title={title}
            aria-label={ariaLabel || title}
        >
            {linkText}
        </RouterLink>
    );
};

export const MainPageLink = ({
    to,
    text,
    icon,
    className = 'btn service-link',
}) => {
    const finalTo = addLangPrefix(to);

    return (
        <RouterLink className={className} to={finalTo}>
            {icon && icon}
            <p
                className="text__center"
                style={{
                    color: '#131313',
                    fontSize: 14,
                    fontWeight: 'bold',
                }}
            >
                {text || null}
            </p>
        </RouterLink>
    );
};

export const MainLink = ({ className = mainBtnClassName, ...props }) => {
    return <Link {...props} className={className} />;
};

export const SecondaryLink = (props) => {
    return <Link {...props} className="btn btn-continue" />;
};

export const DetailsLink = (props) => {
    return <Link {...props} className="btn btn-details" />;
};

export const IconLink = ({
    to,
    text,
    fill,
    icon = iconNames.rightCircle,
    className = 'btn btn-registration',
    size = 24,
}) => {
    const finalTo = addLangPrefix(to);

    return (
        <RouterLink
            className={className}
            style={{
                display: 'flex',
                justifyContent: 'space-evenly',
            }}
            to={finalTo}
        >
            {text} <Icon name={icon} fill={fill} size={size} />
        </RouterLink>
    );
};
